/*================================================================================================================
 Current Offers CONTROLLER
 ================================================================================================================*/
angular
  .module('vppApp')
  .controller('CurrentOffersController', CurrentOffersController);

CurrentOffersController.$inject = ['$scope', 'apiFactory', '$log', '$state', '$rootScope', 'vppConfig', 'SetLiveSwapService', 'OffersFilterService', 'CombineOffersService', 'GetOfferYears', 'EndDateService', '$filter', '$timeout'];

function CurrentOffersController($scope, apiFactory, $log, $state, $rootScope, vppConfig, SetLiveSwapService, OffersFilterService, CombineOffersService, GetOfferYears, EndDateService, $filter, $timeout) {

  /*=======set variables======*/
  //setting Live swap
  var liveswap = SetLiveSwapService.getLSBrandName();
  var lsbrand = vppConfig.lsBrands[liveswap];
  var exlcudedProgramIds = vppConfig.exlcudedProgramIds;
  var brandOrder = vppConfig.brandOrder;
  var siteCode = vppConfig.folderPath;
  //initialize variables
  var makes =['All'];
  var programDetails,
      incentives,
      incentiveYear,
      vehicleDup;
  /*======set $scope variables=====*/
  $scope.showAcc = lsbrand;
  $scope.siteName = vppConfig.siteNames[vppConfig.folderPath];
  $scope.yearList = [];
  $scope.makeDropDown = [];
  //set value to hide drop downs
  $scope.showDropDowns = false;



  $scope.getOffers = function (zipNumber) {
    
    $scope.zipNumber = zipNumber;

    //show drop downs
    $scope.showDropDowns = true;

    //clear any exisiting array
    if($scope.vehicles){
      $scope.vehicles.length = 0;
    }

    $scope.copyYear = year;

    apiFactory.zipCodeToRegion(zipNumber).then(function (response) {

      var jsonPathRegion = response.data.jsonPath;

      apiFactory.getCurrentOffers(jsonPathRegion).then(function (response) {
        //clear storage items when json file is changed
        window.localStorage.removeItem('currentYear_');
        window.localStorage.removeItem('currentMake_');

        //sets programDetails from response to pass to functions
        programDetails = response.data.programDetails;

        //sets incentives from response to pass to functions
        incentives = response.data.incentives;

        //gets the years based on years in incentives from the getOffersYears servicec
        GetOfferYears.getYears(incentives);

        //set it off
        filterVehicles($rootScope.selectedYear);

        //gets end date for disclaimer from EndDateService
        EndDateService.getEndDates(programDetails);

        //gets brands from vehicle list.
        getMakes($scope.vehicles);

        //reduces duplicates brands from vehicle list
        $scope.makes = makes.unique();

        $scope.makeDropDown = $scope.makes;
        $scope.selectedMake = 'All';
        $scope.theSelectedMake = "all";

        //puts brands in appropriate order
        $scope.makes  = $filter('sortBy')($scope.makes,brandOrder);

        //initiallize array for model drop down
        $scope.modelOptions = [];

        //add all vehicles to array
        $scope.modelOptions['All Vehicles'] = "All Vehicles";

        //set default value for model drop down
        $scope.selectedModel = 'All Vehicles';

      });

    }, function errorCallback(response) {
        $scope.serverError = response.data.errors;
        // called asynchronously if an error occurs
        // or server returns response with an error status.
        console.log('errorCode: ' + $scope.serverError);
    });
  };

    $scope.filterDropDown = function (year, make, model) {
      //initialize vairables
      var currentArray;
      //check for storage values or set to defaults
      var storedYear = window.localStorage['currentYear_'] ? window.localStorage['currentYear_'] : $scope.selectedYear;
      var storedMake = window.localStorage['currentMake_'] ? window.localStorage['currentMake_'] : null;

      /*==== check if year drop down is changed ======*/
      if (year && $scope.vehicles) {
        //////////// YEAR

        //set storage value to selected year
        window.localStorage['currentYear_'] = year;

        //start the filtering process
        //filterVehicles(year);
        _resetDropDowns(year);

        //check for stored make value
        
        ////////////  END YEAR
        /*
        if (storedMake) {

          //filter array based on make
          $scope.vehicles = $scope.vehicles.filter(function (vehicle) {
            return (vehicle.make === storedMake);
          });

        } else {

          // if no stored make, set drop down to default
          $scope.selectedMake = 'All';
          $scope.theSelectedMake = "all";
          $scope.selectedModel = 'All Vehicles';
        }
        */
        //////////// Possible Remove For YEAR

        //run function to populalte model drop down
        /*
        getModels(storedMake);
        if ($scope.vehicles.length === 0) {
          $scope.accordion.expandAll();
        } else {
          $scope.accordion.collapseAll();
        }
      } else {
*/
        // if none of the above conditions are  met, then run the filter function based on stored year
         //_resetDropDowns(year);
      }
      //////////// END  YEAR

      /*======= check if make drop down changed =======*/
      if (make) {

        if (make === 'All') {
          $scope.accordion.collapseAll();
          // remove any duplicate vehicles if All Vehicles is clicked
          $scope.vehicles = uniqueByKey($scope.vehicles, 'model');

          $scope.theSelectedMake = "all";
        } else {

          //store make that was clicked
          window.localStorage['currentMake_'] = make;

          //filter array based on make clicked
          $scope.vehicles = OffersFilterService.vehicles;
          $scope.vehicles = $scope.vehicles.filter(function (vehicle) {
            return (vehicle.make === make);
          });
          $scope.accordion.toggle(make);
          $scope.theSelectedMake = make;
        }

        //update model drop down list
        getModels(make);

      }

      /*======= check if model drop down changed =======*/
      if (model) {
        if (model === 'All Vehicles') {
          //filter array based on current model's make
          $scope.vehicles = OffersFilterService.vehicles;
          $scope.vehicles = $scope.vehicles.filter(function (vehicle) {
            return (vehicle.make === vehicle.make);
          });
        } else {
          //filter array to selected model
          $scope.vehicles = OffersFilterService.vehicles;
          $scope.vehicles = $scope.vehicles.filter(function (vehicle) {
            return (vehicle.model === model);
          });
        }
      }
      // console.log($scope.vehicles);
    };
    
    
    ////////////////////////////////

    /*=== get models for drop down menu ====*/
    var getModels = function (make) {

      //initiallize array for model drop down
       delete $scope.modelOptions;
       $scope.modelOptions = [];

      //add all vehicles to array
      //$scope.modelOptions['All Vehicles'] = "All Vehicles";

      //set default value for model drop down
      //$scope.selectedModel = 'All Vehicles';

      if (make == 'All') {
        //if  above condition is met, do nothing for model
      } else {

        //build list of models from array based on make
        for (var i = 0; $scope.vehicles.length > i; i++) {
          if ($scope.vehicles[i].make === make) {
            $scope.modelOptions[$scope.vehicles[i].model] = $scope.vehicles[i].model;
          }
        }
      }
    };

    var getMakes = function (vehicles) {
      for (var i = 0; i < vehicles.length; i++) {
        var currentMake = vehicles[i].make.toLowerCase();
        if ((vppConfig.noCadillac.indexOf(siteCode) > -1) && (currentMake === 'cadillac')) {
        } else {
          makes.push(vehicles[i].make);
        }
      }
    };

    /*==== function to build array, combine and filter offers =====*/
    var filterVehicles = function (year) {
      //calls Offers filter from  ###OffersFiltersService### to get vehicle list
      OffersFilterService.filterOffers(incentives, programDetails, year);

      //adds vehicles array to scope, from OffersFilterService to put on screen
      $scope.vehicles = OffersFilterService.vehicles;
    };

    $scope.ShowZipModal = function () {
      $scope.showModal = true;
    };

    $scope.HideZipModal = function () {
      $scope.showModal = false;
    };
    
    // resetTest
    var _resetDropDowns = function (year) {
       makes = ['All'];
      delete $scope.makeDropDown;
      $scope.makeDropDown = [];
      filterVehicles(year);

      //gets end date for disclaimer from EndDateService
      EndDateService.getEndDates(programDetails);

      //gets brands from vehicle list.
      getMakes($scope.vehicles);

      //reduces duplicates brands from vehicle list
      $scope.makes = makes.unique();
      $scope.makeDropDown = $scope.makes;
      $scope.selectedMake = 'All';
      $scope.theSelectedMake = "all";

      //puts brands in appropriate order
      $scope.makes = $filter('sortBy')($scope.makes, brandOrder);

      //initiallize array for model drop down
      $scope.modelOptions = [];

      //add all vehicles to array
      $scope.modelOptions['All Vehicles'] = "All Vehicles";

      //set default value for model drop down
      $scope.selectedModel = 'All Vehicles';



    };
    
    // get zip code from current location
  $scope.getZip = function () {

    navigator.geolocation.getCurrentPosition(function(position){

      var latcord = position.coords.latitude;
      var longcord = position.coords.longitude;
      var geocoder = new google.maps.Geocoder;
      var latlng = {lat: latcord, lng: longcord};
      
      geocoder.geocode({'location': latlng}, function(results, status) {
        if (status === 'OK') {
          if (results[0]) {
            var address_components = results[0].address_components;
            // console.log(address_components);
            for(var i = 0; i < address_components.length; i++) {
              // console.log(address_components[i]);
              var types = address_components[i].types;
              for(var j = 0; j < types.length; j++) {
                if(types[j] === 'postal_code' && address_components[i].hasOwnProperty("short_name")) {
                  var zip = address_components[i].short_name;
                  $scope.getOffers(zip);
                }
              }
            }
          } else {
            //window.alert('No results found');
          }
        } else {
          window.alert('Geocoder failed due to: ' + status);
        }
      });
    });   
  };

    /*==== function to remove spinner from offers page =====*/
    $timeout(function () {
      var removeSpinner = function () {
        var spinner = document.getElementsByClassName('preloader-mask');
        Array.prototype.forEach.call(spinner, function (el) {
          el.classList.add('loaded');
        }
        )
      };
      removeSpinner();
    }, 10000);
    
      // once page has loaded, get zip from location
  
    $scope.$on('$viewContentLoaded', function (event) {
      $scope.getZip();
    });

    };